import { FC } from 'react';
import { footerReducer } from '../../../antd-reducer/footer-reducer';
import { obtenerIcono } from '../../util/AppIcons';
import { FollowUs } from '../footer/FollowUs';
import './FooterDesktop.less';

export const FooterDesktop:FC<{}> = (props) => {
    return (
    <div className='footer-desktop'>
        <div className='link-section'>
            {
                footerReducer.sections.map(({ key, title, items }) => {
                    return (
                    <div key={key}>
                        
                        { title !== 'SÍGUENOS'

                            ? <div>
                                <p className='title'>{ title }</p>
                                <ul className='list-item'>
                                    {
                                        items.map(({ key, title, url }) => {
                                            return (
                                            <li className='item' key={key}>
                                                <a href={url}>{ title }</a>
                                            </li>
                                            )
                                        })
                                    }
                                </ul>
                            </div>
                            : <FollowUs></FollowUs>
                        }
                    </div>
                    )
                })
            }
        </div>
        <div className='logos-section'>
            <div className='logos'>
                {
                    footerReducer.logos.map(({ icon }) => (
                        <div className={icon === 'derco'? 'logo-left-align' : 'logo'}>
                            { obtenerIcono(`logo-${icon}-footer`) }
                        </div>
                    ))
                }
            </div>
            <div className='divider'></div>
            <p className='copyright'>
                { footerReducer.copyright }
            </p>
        </div>
    </div>
    )
}